export const getFrozenColClass = (key, frozenKeys) => {
  const index = frozenKeys.indexOf(key);
  if (index < 0) return undefined;
  const isLast = index === frozenKeys.length - 1;
  return [
    "reports-frozen-col",
    `reports-frozen-col--${index + 1}`,
    isLast ? "reports-frozen-col--last" : "",
  ]
    .filter(Boolean)
    .join(" ");
};

export const getFreezeVars = (frozenKeys, widths) =>
  frozenKeys.reduce((vars, key, index) => {
    vars[`--reports-frozen-col-${index + 1}-width`] = `${widths[key]}px`;
    return vars;
  }, {});
